/**
 * Base config: only country/locale data and types.
 * No imports of mapLocaleToCountry or mapLocaleToLanguage to avoid circular deps
 * (needed for SSR/build where config.ts is not fully initialized when mappers run).
 */

/**
 * Be careful, if you add a language, make sure to add translations
 */
export const countryLanguageMap: Record<string, string[]> = {
  BE: [`fr`, `nl`],
  GB: [`en`]
  // FR: [`fr`],
};

/**
 * Country - ISO 3166-1
 */
export type Country = keyof typeof countryLanguageMap;

export const availableCountry: Country[] = Object.keys(
  countryLanguageMap
) as Country[];

/**
 * Language - ISO 639-1
 */
export type Language = `fr` | `en` | `nl`;

export const availableLocale = Object.entries(countryLanguageMap).reduce<
  string[]
>((acc, [country, languages]) => {
  return [
    ...acc,
    ...languages.map(
      (language) => `${language as Language}-${country as Country}`
    )
  ];
}, []);

/**
 * Locale - IETF BCP 47
 * en: ISO 639 - Language code
 * US: ISO 3166-1 - Country code
 */
export type Locale = (typeof availableLocale)[number];
